export default "__VITE_ASSET__lgmf$RfL__"